import { ConfirmModal } from '../../../commons/components/ConfirmModal';
import { IssuedInvoice } from '../../types';
import { InvoiceTable } from '../InvoiceTable';
import React from 'react';

export const PauseSubscriptionInvoicesModal = (props: { invoices: IssuedInvoice[] }) => {
  const { invoices } = props;
  return (
    <ConfirmModal
      title="Please pay your outstanding invoices"
      footer={{ type: 'show', applyButton: { label: 'Return to cancellation', onClick: () => {} } }}
      onClose={() => {}}
    >
      <div className="cancellation-intro__description">
        <span>To pause your account, all outstanding invoices must be paid.</span>
        <InvoiceTable invoices={invoices} header="Outstanding invoices" context="pause" />
      </div>
    </ConfirmModal>
  );
};
